import React from 'react';
import { useNavigate } from 'react-router-dom';

export const GroupTable = ({ groups, isLoading, statusClassMap, formatDate }) => {
    const skeletonRows = Array.from({ length: 8 }, (_, index) => index);
    const navigate = useNavigate();

    const handleRowClick = (groupId, groupName) => {
        navigate(`/group/detail/${groupId}`, {
            state: {
                groupName,
            },
        });
    };

    return (
        <div className="table-responsive border rounded-3">
            <table className="table table-hover align-middle mb-0">
                <thead>
                    <tr>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Código</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Grupo</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Usuarios</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Creado por</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Última edición</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Estatus</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading && (
                        <>
                            {skeletonRows.map((row) => (
                                <tr key={`group-skeleton-${row}`}>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--badge"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--name"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--status"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--contact"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--date"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--status"></div></td>
                                </tr>
                            ))}
                        </>
                    )}

                    {!isLoading && groups.map((group) => (
                        <tr key={group._id}>
                            <td className="py-0">
                                <span className="link__nocolor badge bg-soft-primary text-primary" onClick={() => handleRowClick(group._id, group.name)}>{group.code || '-'}</span>
                            </td>
                            <td className="py-0">
                                <div className="link fw-semibold" onClick={() => handleRowClick(group._id, group.name)}>{group.name || '-'}</div>
                            </td>
                            <td className="py-0">{group.usersCount}</td>
                            <td className="py-0">{group.authorName || '-'}</td>
                            <td className="py-0">
                                <div>{group.userUpdatedName || '-'}</div>
                                <div className="fs-12 text-muted">{formatDate(group.updatedDate)}</div>
                            </td>
                            <td>
                                <span className={`badge ${statusClassMap[group.status] || 'bg-soft-secondary text-secondary'}`}>
                                    {group.status || '-'}
                                </span>
                            </td>
                        </tr>
                    ))}

                    {!isLoading && groups.length === 0 && (
                        <tr>
                            <td colSpan={6} className="text-center text-muted py-4">
                                No se encontraron grupos con ese criterio de búsqueda.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
